module.exports = __webpack_public_path__ + "static/media/05-02.c6e7051c.png";